<template>
  <div>
    <!-- Existing image controls -->
    <div v-if="!showUpload">
      <img :src="url" alt="" class="img-thumbnail img-lg">
      <div>
        <a href="#" class="btn btn-default btn-xs" @click="remove"><span class="fa fa-times"></span> Remove</a>
      </div>
    </div>

    <!-- Upload image controls -->
    <div v-if="showUpload">
      <div class="fileinput-new input-group" data-provides="fileinput">
        <div class="input-group-prepend" data-trigger="fileinput">
          <i class="fa fa-file fileinput-exists input-group-addon"></i>
        </div>
        <span class="form-control form-control-sm fileinput-filename" data-trigger="fileinput"></span>
        <span class="btn btn-sm btn-default btn-file input-group-append">
                <span class="fileinput-new">Select file</span>
                <span class="fileinput-exists">Change</span>
                <input type="file" :id="id" ref="files" @change="fileSelected">
              </span>
        <a href="#" class="btn btn-sm btn-default fileinput-exists input-group-append" data-dismiss="fileinput" @click="removeFile">Remove</a>
      </div>
      <div v-if="hasValue">
        <a href="#" class="btn btn-default btn-xs image-cancel" @click="cancel"><span class="fa fa-times"></span> Cancel</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  emits: ['updated'],

  /**
   * Input properties
   */
  props: {
    // Values for edit
    modelValue: {
      type: String,
      default: ''
    },

    // Input id
    id: {
      type: String,
      default: "photo"
    }
  },

  /**
   * Variables (models)
   */
  data () {
    return {
      // File input selected file
      file: '',

      // Show upload controls if true or existing image controls if false
      showUpload: true,

      // Action with existing (old) photo ('' is keep, 'remove' is remove)
      action: ''
    }
  },

  /**
   * Computed values
   */
  computed: {
    // Value is not empty
    hasValue() {
      return this.modelValue;
    },

    // Image URL
    url() {
      return this.modelValue ? '/storage/' + this.modelValue : '#';
    }
  },

  mounted: function () {
    this.init();
  },

  /**
   * Functions (methods)
   */
  methods: {
    /**
     * Init component on value change
     */
    init() {
      this.showUpload = !this.hasValue;
      this.action = '';
    },

    /**
     * File input change
     */
    fileSelected() {
      this.file = this.$refs.files.files[0];
      this.update();
    },

    /**
     * Cancel removing existing image
     */
    cancel() {
      this.showUpload = false;
      this.action = '';
      this.update();
    },

    /**
     * Remove existing image
     */
    remove() {
      this.showUpload = true;
      this.action = 'remove';
      this.update();
    },

    /**
     * Remove attached file
     */
    removeFile() {
      this.file = '';
      this.update();
    },

    /**
     * Update parent value
     */
    update() {
      let parentData = {};
      parentData.file = this.file;
      parentData.action = this.action;
      this.$emit('updated', parentData);
    }
  },

  /**
   * Watchers
   */
  watch: {
    modelValue: function(val) {
      this.init();
    }
  }

}
</script>

<style scoped>

</style>
